import { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import { Login } from './pages/Login'
import { Dashboard } from './pages/Dashboard'
import { Projects } from './pages/Projects'
import { NotFound } from './pages/NotFound'
import { Users } from './pages/Users'

/**
 * Loaded on demand. Reports is the only page that pulls in the charting
 * library, and most of the team will never open it — there is no reason for
 * them to download it on the way to logging fifteen minutes.
 */
const Reports = lazy(() => import('./pages/Reports').then((m) => ({ default: m.Reports })))

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="aurora-bg" />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="projects" element={<Projects />} />

              {/* Rendering is gated here; the API gates itself as well —
                  hiding the link is not access control. */}
              <Route element={<ProtectedRoute managerOnly />}>
                <Route
                  path="reports"
                  element={
                    <Suspense fallback={<p className="muted">Loading…</p>}>
                      <Reports />
                    </Suspense>
                  }
                />
                <Route path="users" element={<Users />} />
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
